<template>
	<body style="margin:0px;padding:0px;overflow:hidden;height: 100vh;">
		<iframe
			:src="documentLink"
			frameborder="0"
			style="overflow:hidden;height:100%;width:100%"
			height="100%"
			width="100%"
		>
		</iframe>
	</body>
</template>
<script>
export default {
	props: {
		documentLink: {
			type: String,
			default: null,
		},
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	data() {
		return {
			isLoading: false,
		};
	},
	components: {},
	mounted() {},
};
</script>
